"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.State = void 0;
/**
 * State
 */
var State = /** @class */ (function (_super) {
    __extends(State, _super);
    function State() {
        var _this = _super.call(this) || this;
        _this._size = new PIXI.Point();
        return _this;
    }
    /**
     * Inits state
     * @param pSize
     */
    State.prototype.init = function (pSize, pData) {
        this.onResize(pSize);
    };
    /**
     * Animates in
     * @param pOnComplete
     */
    State.prototype.animateIn = function (pOnComplete) {
        pOnComplete();
    };
    /**
     * Updates state
     * @param pDeltaTime
     */
    State.prototype.update = function (pDeltaTime) {
        // override
    };
    /**
     * Determines whether resize on
     * @param pSize
     */
    State.prototype.onResize = function (pSize) {
        this._size.copyFrom(pSize);
        this.position.set(this._size.x * 0.5, this._size.y * 0.5);
    };
    /**
     * Animates out
     * @param pOnComplete
     */
    State.prototype.animateOut = function (pOnComplete) {
        pOnComplete();
    };
    /**
     * Destroys state.
     * @param pOptions
     */
    State.prototype.destroy = function (pOptions) {
        if (pOptions === void 0) { pOptions = { children: true }; }
        _super.prototype.destroy.call(this, pOptions);
    };
    return State;
}(PIXI.Container));
exports.State = State;
//# sourceMappingURL=State.js.map